"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Registration Service
 * Provides endpoints for users to register for the EVE and SAVE on-boarding processes.<br><br> Users created here will have a role of REGISTRATION. Once created they login through the normal legacy-idp process at which point the applications direct them to their respective on-boarding process.
 *
 * The version of the OpenAPI document: 1.0.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var RegistrationApi = /** @class */ (function (_super) {
    __extends(RegistrationApi, _super);
    function RegistrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Captures the User\'s profile information and sends an email containing their logonId/password along with a verification link containing a one-time code. <br><br> Possible System Error Code:   * `EMAIL_SEND_FAILURE` Unable to send the confirmation email
     * Initiates the registration
     */
    RegistrationApi.prototype.initiateRegistrationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.registrationRequest === null || requestParameters.registrationRequest === undefined) {
                            throw new runtime.RequiredError('registrationRequest', 'Required parameter requestParameters.registrationRequest was null or undefined when calling initiateRegistration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/registration",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.RegistrationRequestToJSON(requestParameters.registrationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Captures the User\'s profile information and sends an email containing their logonId/password along with a verification link containing a one-time code. <br><br> Possible System Error Code:   * `EMAIL_SEND_FAILURE` Unable to send the confirmation email
     * Initiates the registration
     */
    RegistrationApi.prototype.initiateRegistration = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initiateRegistrationRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates a new one <br><br> Validation Error Codes for 400 response:   * `OTC_NOT_EXPIRED` The current OTC is not expired yet   * `OTC_ALREADY_VERIFIED` The one-time code was previously verified   * `OTC_NOT_PRESENT` The one-time code does not exist Possible System Error Code:   * `EMAIL_SEND_FAILURE` Unable to send the confirmation email
     * Renews an unverified registration with a new one-time code
     */
    RegistrationApi.prototype.renewRegistrationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.renewalRequest === null || requestParameters.renewalRequest === undefined) {
                            throw new runtime.RequiredError('renewalRequest', 'Required parameter requestParameters.renewalRequest was null or undefined when calling renewRegistration.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/registration/renew",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.RenewalRequestToJSON(requestParameters.renewalRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Generates a new one <br><br> Validation Error Codes for 400 response:   * `OTC_NOT_EXPIRED` The current OTC is not expired yet   * `OTC_ALREADY_VERIFIED` The one-time code was previously verified   * `OTC_NOT_PRESENT` The one-time code does not exist Possible System Error Code:   * `EMAIL_SEND_FAILURE` Unable to send the confirmation email
     * Renews an unverified registration with a new one-time code
     */
    RegistrationApi.prototype.renewRegistration = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.renewRegistrationRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * When the user clicks on the link in their email the legacy-idp-ui will invoke this endpoint providing the one-time code included in that link.<br> If that code is valid the User will be created in vis-user-service and the legacy-idp-ui will present the standard login flow.<br><br> Validation Error Codes for 400 response:   * `OTC_TIMEOUT` The one-time code provided has timed out   * `OTC_ALREADY_VERIFIED` The one-time code was previously verified   * `OTC_NOT_PRESENT` The one-time code does not exist
     * Verifies the registration
     */
    RegistrationApi.prototype.verifyRegistrationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.otc === null || requestParameters.otc === undefined) {
                            throw new runtime.RequiredError('otc', 'Required parameter requestParameters.otc was null or undefined when calling verifyRegistration.');
                        }
                        queryParameters = {};
                        if (requestParameters.otc !== undefined) {
                            queryParameters['otc'] = requestParameters.otc;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/registration",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * When the user clicks on the link in their email the legacy-idp-ui will invoke this endpoint providing the one-time code included in that link.<br> If that code is valid the User will be created in vis-user-service and the legacy-idp-ui will present the standard login flow.<br><br> Validation Error Codes for 400 response:   * `OTC_TIMEOUT` The one-time code provided has timed out   * `OTC_ALREADY_VERIFIED` The one-time code was previously verified   * `OTC_NOT_PRESENT` The one-time code does not exist
     * Verifies the registration
     */
    RegistrationApi.prototype.verifyRegistration = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyRegistrationRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return RegistrationApi;
}(runtime.BaseAPI));
exports.RegistrationApi = RegistrationApi;
